import { c as _c } from "react/compiler-runtime";
import { ReactNode } from 'react';
import { CustomerAttentionToolSlot } from '@/types/amplience';
import { isScheduledItemExpired } from '@/utility/isScheduledItemExpired';
import AnnouncementBar from '../AnnouncementBar/AnnouncementBar';
import { CustomerAttentionItem } from './CustomerAttentionItem';
import { HeaderBannerContainer } from './HeaderBannerContainer';
export type HeaderBannerProps = {
  customerAttentionToolSlot: CustomerAttentionToolSlot | null;
  children: ReactNode;
};
function HeaderBanner(t0) {
  const $ = _c(5);
  const {
    customerAttentionToolSlot,
    children
  } = t0;
  if (!customerAttentionToolSlot || isScheduledItemExpired(customerAttentionToolSlot.content._meta)) {
    let t1;
    if ($[0] !== children) {
      t1 = <HeaderBannerContainer>{children}</HeaderBannerContainer>;
      $[0] = children;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  let t1;
  if ($[2] !== children || $[3] !== customerAttentionToolSlot.content.item) {
    t1 = <HeaderBannerContainer>{customerAttentionToolSlot.content.item.showBeforePromo ? <><AnnouncementBar backgroundColor={customerAttentionToolSlot.content.item.backgroundColor} textColor={customerAttentionToolSlot.content.item.textColor}><CustomerAttentionItem item={customerAttentionToolSlot.content.item} /></AnnouncementBar>{children}</> : <>{children}<AnnouncementBar backgroundColor={customerAttentionToolSlot.content.item.backgroundColor} textColor={customerAttentionToolSlot.content.item.textColor}><CustomerAttentionItem item={customerAttentionToolSlot.content.item} /></AnnouncementBar></>}</HeaderBannerContainer>;
    $[2] = children;
    $[3] = customerAttentionToolSlot.content.item;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
}
export default HeaderBanner;